import { PanelViewBase } from '@softline/ui-core';
import { Signal } from '@angular/core';
import { LoadingState } from '@softline/core';

export abstract class RemoteDataPanelViewBase<T> extends PanelViewBase {
  abstract data: Signal<T | null>;
  abstract loadingState: Signal<LoadingState>;
  abstract loadingError: Signal<Error | null>;
}
